import ServiceUnavailableAlert from 'components/core/ServiceUnavailableAlert';
import { Alert, Button } from 'react-bootstrap';
import { isInfrastructureError } from 'utils/apiErrors';

export default function ErroBuscaAtividades({ error, onRetry, stale = false }) {
  if (isInfrastructureError(error)) {
    return <ServiceUnavailableAlert error={error} onRetry={onRetry} stale={stale} />;
  }

  const message =
    error?.response?.data?.error || error?.response?.data?.message || 'Erro ao buscar atividades.';

  return (
    <Alert variant={stale ? 'warning' : 'danger'} className="text-center mb-0">
      <p className="mb-2">
        {stale
          ? 'Não foi possível atualizar as atividades. A lista pode estar desatualizada.'
          : message}
      </p>
      <Button variant={stale ? 'outline-warning' : 'outline-danger'} size="sm" onClick={onRetry}>
        Tentar novamente
      </Button>
    </Alert>
  );
}
